<script setup lang="ts">

import CategoryPanel from '../Components/CategoryPanel.vue';

type Props = {
    currentCategory: number
}

defineProps<Props>();

const emit = defineEmits( [ 'on-category-selected' ] );

</script>

<template>

    <div class="p-8 flex flex-col items-center justify-center">

        <h1 class="text-3xl 3xl:text-4xl text-white font-semibold uppercase">
            Wear &amp; Tear Protection
        </h1>

        <p class="text-xl 3xl:text-2xl text-indigo-400 mb-8">
            Looks after the parts of your car that your warranty doesn't cover
        </p>

        <h2 class="text-xl 3xl:text-2xl text-indigo-300 font-semibold mb-4">
            Select your vehicle category
        </h2>

        <div class="flex gap-3 w-[980px] text-white justify-evenly drop-shadow-xl">

            <CategoryPanel 
                :category="1"
                :current-category="currentCategory"
                @on-category-selected="c => emit( 'on-category-selected', c )">
                <template #title>Everyday Cars</template>
                Toyota*, Kia, Hyundai, Mazda, Suzuki, Nissan, Subaru, Honda
                <br/><br/>
                *Excludes Toyota Tundra
            </CategoryPanel>

            <CategoryPanel 
                :category="2"
                :current-category="currentCategory"
                @on-category-selected="c => emit( 'on-category-selected', c )">
                <template #title>Chinese Brands</template>
                MG, BYD Hybrid, Haval, GWM, Chery, Geely Hybrid
            </CategoryPanel>

            <CategoryPanel 
                :category="3"
                :current-category="currentCategory"
                @on-category-selected="c => emit( 'on-category-selected', c )">
                <template #title>Premium &amp; Commercial</template>
                Renault, VW, Skoda, Peugeot, Citroen, Cupra, Mini, Fiat, Isuzu, 
                Ford*, Mitsubishi, LDV, KGM (Ssangyong), Jaecoo, Jeep, Mahindra, 
                SUV's, 4WD’s, UTE's*, Light Commercial Vehicle’s
                <br/><br/>
                *Excludes Ford F150
            </CategoryPanel>

            <CategoryPanel 
                :category="4"
                :current-category="currentCategory"
                @on-category-selected="c => emit( 'on-category-selected', c )">
                <template #title>Luxury Brands</template>
                Mercedes-Benz, BMW, Audi, Volvo, Jaguar, Lexus, Land Rover, Genesis, 
                Ram, GMSZ, Porsche, Alfa Romeo, Ineos, Chevrolet, 
                Ford F150, Toyota Tundra
            </CategoryPanel>

        </div>
        
        <h2 class="absolute text-2xl text-indigo-300 font-semibold mb-4 bottom-[4.5rem] 3xl:bottom-32">
            How Does It Work?
        </h2>

    </div>

</template>